/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_TitleInputs */

const vi_phase_title = /** @type {(inputs: Phase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giai đoạn sinh trưởng`)
};

/**

* @param {Phase_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const phase_title = /** @type {((inputs?: Phase_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_phase_title(inputs)
});